import { useHseSummary } from "@dashboard/hooks/useHseSummary";
import { faBolt } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { StatCard } from "./StatCard";

export default function YourIssues() {
    const { t } = useTranslation();
    const { data: summary, isPending, isError } = useHseSummary();

    const linkHref = summary && !Array.isArray(summary.links) ? summary.links.issues : undefined;

    return (
        <StatCard
            label={t("dashboard.yourIssues")}
            value={summary?.metrics.issues.total}
            isPending={isPending}
            isError={isError}
            icon={faBolt}
            variant="yellow"
            linkHref={linkHref}
            linkLabel={t("dashboard.manageIssues")}
        />
    );
}
